import React from 'react';

interface SkillsQuestionsProps {
  responses: Record<string, any>;
  onChange: (responses: Record<string, any>) => void;
}

export function SkillsQuestions({ responses, onChange }: SkillsQuestionsProps) {
  const skillLevels = ['Beginner', 'Intermediate', 'Advanced', 'Expert'];

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Your Skills Assessment</h2>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="technical_skills" className="block text-sm font-medium text-gray-700">
            Rate your technical skills
          </label>
          <select
            id="technical_skills"
            value={responses.technical_skills || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange({ technical_skills: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select skill level</option>
            {skillLevels.map(level => (
              <option key={level.toLowerCase()} value={level.toLowerCase()}>
                {level}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="soft_skills" className="block text-sm font-medium text-gray-700">
            Rate your soft skills
          </label>
          <select
            id="soft_skills"
            value={responses.soft_skills || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange({ soft_skills: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select skill level</option>
            {skillLevels.map(level => (
              <option key={level.toLowerCase()} value={level.toLowerCase()}>
                {level}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="improvement_areas" className="block text-sm font-medium text-gray-700">
            What skills would you like to improve?
          </label>
          <textarea
            id="improvement_areas"
            value={responses.improvement_areas || ''}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange({ improvement_areas: e.target.value })}
            rows={3}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
            placeholder="List the skills you'd like to develop..."
          />
        </div>
      </div>
    </div>
  );
}